module.exports = __webpack_public_path__ + "static/media/Build-Space.49936b63.png";